

























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import constants      from '@/constants';

import SiteReference from '@/models/SiteReference';

/** How long to wait after the *last* keystroke before firing the XHR to get results */
const DEBOUNCE_TIMER = 150;

/** How many suggestions show in autocomplete  */
const NUM_AUTOCOMPLETE_SUGGESTIONS = 20;

@Component({
  name: 'MobileSearchWidgetRecentView'
})

export default class MobileSearchWidgetRecentView extends Vue {

  // Expose routenames for use in template
  searchRouteName   = constants.RouteNames.Search;
  miniDetailRouteName    = constants.RouteNames.MiniDetail;

  /** 
   * The five most recent sites the user looked at, stored in local storage 
   */
  get recentSites(): Array<SiteReference> {
    return this.$store.state.uiState.recentSites.slice(0, 5);
  }

  /**
   * The five most recent searches the user did, stored in local storage 
   */
  get recentSearches() {
    return this.$store.state.uiState.recentSearches.slice(0, 5);
  }

  /**
   * ??? why is this needed here ???
   */
  get currentRoute() {
    return this.$router.currentRoute;
  }

  handleRouterLinkClick() {

    // Signal to parent to open the tray to show search results
    this.$emit('closewidget');
  }

}
